<template>
  <div class="pie-card">
    <div class="pie-card__chart">
      <PieChart
        :data="data"
        :colors="chartColors"
        :inner-radius="innerRadius"
        :outer-radius="outerRadius"
      />
      <div class="pie-card__center">
        <slot name="center" />
      </div>
    </div>
    <div v-if="$slots.legend" class="pie-card__legend">
      <slot name="legend" />
    </div>
  </div>
</template>

<script>
import PieChart from "./PieChart.vue";

export default {
  components: { PieChart },
  props: {
    data: { type: Array, default: () => [] },
    innerRadius: { type: Number, default: 65 },
    outerRadius: { type: Number, default: 90 },
  },
  computed: {
    chartColors() {
      return this.data.map(item => item.color || (item.colorStops ? item.colorStops[0] : undefined))
    },
  },
};
</script>

<style scoped lang="less">
.pie-card {
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;

  &__chart {
    position: relative;
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    /* ponytail: fixed pie-canvas size; smaller for dense multi-panel layouts.
       140px for spacious panels, 110px for compact ones via .pie-card--compact. */
    :deep(.pie-chart) {
      width: 140px !important;
      height: 140px !important;
    }
  }

  &__center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    pointer-events: none;
  }

  &__legend {
    flex-shrink: 0;
    padding: 4px 6px;
  }
}
</style>
